<div
  class="flex cursor-pointer items-center justify-between py-4"
  (click)="openCompound.emit($event)"
  [style.color]="descriptionColor | contentBuilderColor"
>
  <div>
    @if (name) {
      <div
        class="flex items-center font-accent text-md font-bold leading-6"
        [style.color]="headingColor | contentBuilderColor"
      >
        @if (isValid && products?.length) {
          <span><i class="icon icon-check-circle mr-1.5 mt-1 text-success-600"></i></span>
        }
        @if (isValid === false) {
          <span><i class="icon icon-warning-circle mr-1.5 mt-1 text-neutral-800"></i></span>
        }
        <span>{{ name }}</span>
      </div>
    }
    @if (description) {
      <div class="font-base text-sm font-normal">
        {{ description }}
      </div>
    }
    @if (!hideAdditionGroupDetails) {
      @if ((!minCount && count) || (minCount === count && count !== null && count > 0)) {
        <div class="flex items-center justify-between leading-6">
          <span
            [class.text-secondary-700]="isValid === false"
            class="font-base text-base font-normal"
            [style.color]="inactiveStateColor | contentBuilderColor"
            >{{ 'product-add-modal.choose' | translate }} {{ count }}
            @if (minCount === 0) {
              <span>({{ 'product-add-modal.optional' | translate }})</span>
            }
          </span>
        </div>
      }
      @if (minCount && count === null) {
        <div class="flex items-center justify-between leading-6">
          <span
            [class.text-secondary-700]="isValid === false"
            class="font-base text-base font-normal"
            [style.color]="inactiveStateColor | contentBuilderColor"
            >{{ 'product-add-modal.choose-at-least' | translate }} {{ minCount }}</span
          >
        </div>
      } @else if (minCount && minCount !== count) {
        <div class="flex items-center justify-between leading-6">
          <span
            [class.text-secondary-700]="isValid === false"
            class="font-base text-base font-normal"
            [style.color]="inactiveStateColor | contentBuilderColor"
            >{{ 'product-add-modal.choose-from' | translate }} {{ minCount }}
            {{ 'product-add-modal.to' | translate }} {{ count }}</span
          >
        </div>
      }
    }
    @if (selectedItems$ | async; as items) {
      <div class="font-base text-base font-bold font-normal">
        @for (item of items; track item; let last = $last) {
          <span>
            {{ item.name }}
            @if (item.quantity > 1) {
              <span class="notranslate"> &times; {{ item.quantity }}</span>
            }
            @if (!last && (items?.length ?? 0) > 1) {
              <span>, </span>
            }
            @if (item.additions?.length) {
              <span> - </span>
            }
            @for (addition of item.additions; track addition; let lastAddition = $last) {
              <span
                >{{ addition.name }}
                @if (addition.quantity > 1) {
                  <span class="notranslate">&times; {{ addition.quantity }}</span>
                }
                @if (!lastAddition && (item.additions?.length ?? 0) > 1) {
                  <span>, </span>
                }
              </span>
            }
          </span>
        }
      </div>
    }
  </div>
  <div class="ml-2">
    <i class="icon icon-arrow-down-s"></i>
  </div>
</div>
